import { render, staticRenderFns } from "./Songwriters.vue?vue&type=template&id=1e759b86"
import script from "./Songwriters.vue?vue&type=script&lang=js"
export * from "./Songwriters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports